export default __webpack_public_path__ + "assets/audios/b11c3ea89aae5be35c38416fdc899e37.mp3";